import { Grid, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Variant } from '@mui/material/styles/createTypography';
import { AppTypography } from './AppTypography/AppTypography';

export const Asterisk = styled((props: React.HTMLAttributes<HTMLSpanElement>) => <span {...props}> *</span>)(
	({ theme }) => ({
		color: theme.palette.error.main,
	})
);

interface RequiredFieldsProps {
	fontSize?: Variant;
}

export const RequiredFields = ({ fontSize = 'body1' }: RequiredFieldsProps) => {
	const { t } = useTranslation();

	return (
		<Grid container>
			<AppTypography
				text={
					<>
						<Asterisk style={{ marginRight: 5 }} />
						{t('common.requiredFields')}
					</>
				}
				element={fontSize}
				textAlign='left'
			/>
			<span></span>
		</Grid>
	);
};
